module.exports = __webpack_public_path__ + "media/src/images/icons/information-a61bfa1cb6138eb18e5dc305092fe7d0.svg";